<template>
  <BaseCard
    class="hrm-card max-w-xs w-100 border-t-gray rounded-md shadow-1"
    :full-bleed="true"
  >
    <div class="bg-gray-7 p-9 text-center">
      <AvatarImage
        image="/assets/images/market/beautiful-people/ashley-medows.jpg"
        :size="140"
        class="avatar-image mx-auto mb-2"
      />
      <TypeBody
        :variant="$options.Typography.Body.LARGE"
        :weight="$options.Typography.Weights.STRONG"
        tag="p"
        class="hrm-name mb-2"
      >
        Ashley Medows
      </TypeBody>
      <svg
        width="105"
        height="24"
        viewBox="0 0 105 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="mx-auto"
        style="margin: 0 auto"
      >
        <g clip-path="url(#clip0)">
          <path
            d="M96.2161 3.66019H18.3203L12.8605 0.473101C11.7761 -0.159694 10.0744 -0.159694 8.98997 0.473101L1.9324 4.5935C0.847947 5.22629 0 6.70859 0 7.96841V16.1254C0 17.3852 0.853716 18.8617 1.94393 19.4888L8.98709 23.5311C9.5322 23.8432 10.2302 23.9992 10.9281 23.9992C11.6261 23.9992 12.3241 23.8432 12.8692 23.5311L18.675 20.1967H96.2161C100.767 20.1967 104.468 16.4866 104.468 11.9299C104.468 7.37317 100.767 3.66019 96.2161 3.66019ZM16.0995 9.84079L9.73409 15.9491C9.51778 16.1572 9.16879 16.1572 8.95248 15.9491L5.35591 12.4962C5.1396 12.2882 5.1396 11.953 5.35591 11.745L6.13752 10.9937C6.35384 10.7856 6.70282 10.7856 6.91914 10.9937L9.34184 13.3197L14.5334 8.33826C14.7497 8.13022 15.0987 8.13022 15.315 8.33826L16.0966 9.08952C16.3158 9.29756 16.3158 9.63563 16.0995 9.84079ZM96.2161 18.7693H20.7632C21.4092 18.0382 21.8476 17.0269 21.8476 16.1254V7.96841C21.8476 6.96865 21.3112 5.83308 20.5497 5.0876H96.2161C99.9828 5.0876 103.046 8.15622 103.046 11.9299C103.046 15.7035 99.9828 18.7693 96.2161 18.7693Z"
            fill="#481D72"
          />
          <path
            d="M29.1906 11.8584C29.6203 11.7688 29.9722 11.3874 29.9722 10.8153C29.9722 10.2085 29.5281 9.65659 28.6657 9.65659H26.7881C26.4622 9.65659 26.2776 9.84151 26.2776 10.168L26.2805 13.6874C26.2805 14.0226 26.4651 14.2046 26.791 14.2046L28.7436 14.2017C29.6088 14.2017 30.0645 13.6556 30.0645 12.9737C30.0616 12.4016 29.6751 11.9306 29.1906 11.8584ZM27.2438 10.4801H28.4551C28.7811 10.4801 28.9858 10.6968 28.9858 10.9771C28.9858 11.2689 28.7811 11.4827 28.4551 11.4827H27.2438V10.4801ZM28.4898 13.3782H27.2438V12.3062H28.4898C28.8705 12.3062 29.0752 12.5518 29.0752 12.8379C29.0752 13.1673 28.8589 13.3782 28.4898 13.3782Z"
            fill="#481D72"
          />
          <path
            d="M34.0562 10.1477C33.9322 9.827 33.6207 9.60162 33.2602 9.60162C32.8939 9.60162 32.5853 9.827 32.4642 10.1477L31.1403 13.5862C31.1201 13.6353 31.1057 13.696 31.1057 13.7567C31.1057 14.0283 31.3249 14.2479 31.596 14.2479C31.8066 14.2479 31.9969 14.1121 32.0575 13.9214L32.2421 13.3897L34.2841 13.3868L34.4687 13.9185C34.5292 14.1092 34.7138 14.245 34.9244 14.245C35.1955 14.245 35.4204 14.0254 35.4204 13.7538C35.4204 13.6931 35.4003 13.6324 35.3801 13.5833L34.0562 10.1477ZM32.5391 12.5489L33.2602 10.4887L33.9841 12.5489H32.5391Z"
            fill="#481D72"
          />
          <path
            d="M40.7533 9.59879C40.4187 9.59879 40.1274 9.80972 40.0178 10.1102L39.0863 12.4854L38.1604 10.1131C38.0451 9.81261 37.7595 9.60167 37.4192 9.60167C36.9837 9.60167 36.6289 9.95708 36.6318 10.3934L36.6347 13.7625C36.6347 14.0226 36.8539 14.248 37.125 14.2451C37.3904 14.2451 37.6009 14.0197 37.6009 13.7596L37.598 10.9222L38.8324 14.0659C38.8728 14.167 38.9767 14.2422 39.092 14.2422C39.2074 14.2422 39.3112 14.167 39.3516 14.0659L40.5802 10.9222L40.5831 13.7596C40.5831 14.0197 40.8023 14.2451 41.0677 14.2422C41.3388 14.2422 41.558 14.0168 41.558 13.7567L41.5551 10.3876C41.5493 9.9513 41.1946 9.59879 40.7533 9.59879Z"
            fill="#481D72"
          />
          <path
            d="M45.9736 11.8438C46.4034 11.7543 46.7553 11.3729 46.7553 10.8007C46.7553 10.194 46.3111 9.64206 45.4487 9.64206H43.5711C43.2452 9.64206 43.0606 9.82699 43.0606 10.1535L43.0635 13.6729C43.0635 14.0081 43.2481 14.1901 43.574 14.1901L45.5266 14.1872C46.3919 14.1872 46.8476 13.6411 46.8476 12.9592C46.8476 12.39 46.4582 11.919 45.9736 11.8438ZM44.0268 10.4685H45.2382C45.5641 10.4685 45.7689 10.6852 45.7689 10.9654C45.7689 11.2573 45.5641 11.4711 45.2382 11.4711H44.0268V10.4685ZM45.2757 13.3666H44.0297V12.2946H45.2757C45.6564 12.2946 45.8612 12.5402 45.8612 12.8263C45.8612 13.1528 45.642 13.3666 45.2757 13.3666Z"
            fill="#481D72"
          />
          <path
            d="M51.0267 13.3493L49.1549 13.3522V12.2946H50.9777C51.2084 12.2946 51.3988 12.1097 51.3988 11.8785C51.3988 11.6532 51.2084 11.4625 50.9777 11.4625H49.152V10.4743L51.0239 10.4714C51.2546 10.4714 51.4449 10.2864 51.4449 10.0611C51.4449 9.82123 51.2546 9.63919 51.0239 9.63919L48.6963 9.64208C48.3704 9.64208 48.1858 9.82701 48.1858 10.1535L48.1887 13.6729C48.1887 14.0081 48.3733 14.1901 48.6992 14.1901L51.0267 14.1872C51.2575 14.1872 51.4478 13.9965 51.4478 13.7654C51.4478 13.54 51.2575 13.3493 51.0267 13.3493Z"
            fill="#481D72"
          />
          <path
            d="M55.6069 13.3435L53.7351 13.3464V12.2889H55.5579C55.7886 12.2889 55.979 12.104 55.979 11.8728C55.979 11.6474 55.7886 11.4567 55.5579 11.4567H53.7351V10.4685L55.6069 10.4656C55.8377 10.4656 56.028 10.2807 56.028 10.0553C56.028 9.81549 55.8377 9.63345 55.6069 9.63345L53.2794 9.63634C52.9535 9.63634 52.7689 9.82127 52.7689 10.1478L52.7718 13.6672C52.7718 14.0023 52.9564 14.1844 53.2823 14.1844L55.6098 14.1815C55.8405 14.1815 56.0309 13.9908 56.0309 13.7596C56.028 13.5342 55.8377 13.3435 55.6069 13.3435Z"
            fill="#481D72"
          />
          <path
            d="M63.149 12.8205C63.0135 12.8205 62.8895 12.8812 62.8087 12.9708C62.578 13.2366 62.2521 13.4013 61.8685 13.4013C61.0782 13.4013 60.4783 12.7685 60.4783 11.9104C60.4783 11.0522 61.0753 10.4165 61.8656 10.4165C62.2463 10.4165 62.5722 10.587 62.7972 10.8384C62.8866 10.9395 63.0077 10.9944 63.1433 10.9944C63.3942 10.9944 63.599 10.7892 63.599 10.5379C63.599 10.4223 63.5586 10.3067 63.4836 10.2316C63.1231 9.83571 62.6126 9.55832 61.8627 9.55832C60.536 9.55832 59.4804 10.5147 59.4833 11.9132C59.4833 13.3117 60.5389 14.2653 61.8685 14.2653C62.6184 14.2653 63.1289 13.9792 63.4894 13.5834C63.5644 13.5082 63.6048 13.3984 63.6048 13.2829C63.6048 13.0257 63.4 12.8205 63.149 12.8205Z"
            fill="#481D72"
          />
          <path
            d="M67.7636 13.3349H65.8918V12.2774H67.7146C67.9453 12.2774 68.1357 12.0924 68.1357 11.8613C68.1357 11.6359 67.9453 11.4452 67.7146 11.4452H65.8918V10.457H67.7636C67.9944 10.457 68.1847 10.2721 68.1847 10.0467C68.1847 9.80685 67.9944 9.62482 67.7636 9.62482L65.4361 9.62771C65.1102 9.62771 64.9256 9.81263 64.9256 10.1391L64.9285 13.6585C64.9285 13.9937 65.1131 14.1757 65.439 14.1757L67.7665 14.1729C67.9972 14.1729 68.1876 13.9821 68.1876 13.751C68.1847 13.5256 67.9944 13.3349 67.7636 13.3349Z"
            fill="#481D72"
          />
          <path
            d="M72.289 12.4045C72.7389 12.2398 73.1542 11.8179 73.1514 11.0869C73.1514 10.2403 72.5716 9.62192 71.6256 9.62192H70.0134C69.6875 9.62192 69.5029 9.80684 69.5029 10.1334L69.5058 13.7336C69.5058 13.9937 69.725 14.2191 69.9961 14.2162C70.2614 14.2162 70.472 13.9908 70.472 13.7308V12.5374H71.268L72.289 14.0081C72.3697 14.1237 72.5197 14.2133 72.6899 14.2133C72.9495 14.2133 73.1514 13.9879 73.1514 13.7568C73.1514 13.621 73.1167 13.5314 73.0562 13.4505L72.289 12.4045ZM71.4843 11.711H70.4691V10.457H71.4843C71.8708 10.457 72.165 10.7026 72.165 11.084C72.165 11.4654 71.8737 11.711 71.4843 11.711Z"
            fill="#481D72"
          />
          <path
            d="M77.3912 9.61902L74.5243 9.62191C74.2936 9.62191 74.0946 9.81261 74.0946 10.0524C74.0946 10.2836 74.2936 10.4743 74.5243 10.4743H75.4703L75.4732 13.7336C75.4732 13.9937 75.6924 14.2162 75.9635 14.2162C76.2289 14.2162 76.448 13.9908 76.4452 13.7307L76.4423 10.4714H77.3883C77.619 10.4714 77.818 10.2807 77.818 10.0496C77.8209 9.80972 77.6219 9.61902 77.3912 9.61902Z"
            fill="#481D72"
          />
          <path
            d="M79.488 9.56985C79.2169 9.56985 78.9977 9.78946 78.9977 10.0553L79.0006 13.7307C79.0006 13.9908 79.2198 14.2161 79.4909 14.2132C79.7562 14.2132 79.9668 13.9879 79.9668 13.7278L79.9639 10.0524C79.9639 9.78657 79.7534 9.56985 79.488 9.56985Z"
            fill="#481D72"
          />
          <path
            d="M84.7342 10.0351C84.7342 9.79532 84.5438 9.61328 84.3131 9.61328L81.9855 9.61617C81.6596 9.61617 81.475 9.8011 81.475 10.1276L81.4779 13.7279C81.4779 13.988 81.6971 14.2133 81.9682 14.2104C82.2336 14.2104 82.4441 13.9851 82.4441 13.725V12.2658H84.2669C84.4977 12.2658 84.688 12.0809 84.688 11.8497C84.688 11.6244 84.4977 11.4337 84.2669 11.4337H82.4441V10.4455L84.316 10.4426C84.5438 10.4455 84.7342 10.2605 84.7342 10.0351Z"
            fill="#481D72"
          />
          <path
            d="M86.4617 9.56406C86.1906 9.56406 85.9714 9.78366 85.9714 10.0495L85.9743 13.7249C85.9743 13.985 86.1935 14.2103 86.4646 14.2074C86.73 14.2074 86.9405 13.9821 86.9405 13.722L86.9376 10.0466C86.9405 9.78366 86.7271 9.56406 86.4617 9.56406Z"
            fill="#481D72"
          />
          <path
            d="M91.29 13.3176H89.4182V12.2601H91.241C91.4717 12.2601 91.6621 12.0751 91.6621 11.844C91.6621 11.6186 91.4717 11.4279 91.241 11.4279H89.4182V10.4397H91.29C91.5208 10.4397 91.7111 10.2548 91.7111 10.0294C91.7111 9.78955 91.5208 9.60751 91.29 9.60751L88.9625 9.6104C88.6366 9.6104 88.452 9.79533 88.452 10.1218L88.4549 13.6412C88.4549 13.9764 88.6395 14.1584 88.9654 14.1584L91.2929 14.1556C91.5236 14.1556 91.714 13.9648 91.714 13.7337C91.714 13.5083 91.5236 13.3176 91.29 13.3176Z"
            fill="#481D72"
          />
          <path
            d="M94.8201 9.60749H93.5395C93.2136 9.60749 93.029 9.79242 93.029 10.1189L93.0319 13.6383C93.0319 13.9735 93.2165 14.1555 93.5424 14.1555H94.8229C96.2448 14.1555 97.2312 13.254 97.2312 11.8844C97.2312 10.5119 96.2448 9.6046 94.8201 9.60749ZM94.8229 13.3031H93.9981L93.9952 10.4599H94.8172C95.7488 10.4599 96.2391 11.0782 96.242 11.8844C96.2448 12.653 95.7228 13.3002 94.8229 13.3031Z"
            fill="#481D72"
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="104.471" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>

      <ul class="check-list list-none p-0 mt-2">
        <li
          v-for="(item, index) in checklist"
          :key="`checklist-${index}`"
          class="checklist-item flex items-center justify-center mb-3"
        >
          <div
            class="rounded-box rounded-md w-6 h-6 flex items-center justify-center mr-3"
          >
            <svg
              viewBox="0 0 24 18"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              style="height: 9px; margin: 0 auto; width: 12px"
              class="text-secondary"
            >
              <path
                d="M8.15121 17.5967L0.351213 9.7967C-0.117396 9.32809 -0.117396 8.56829 0.351213 8.09964L2.04823 6.40257C2.51684 5.93392 3.27668 5.93392 3.74529 6.40257L8.99974 11.657L20.2542 0.402574C20.7228 -0.0660354 21.4827 -0.0660354 21.9513 0.402574L23.6483 2.09964C24.1169 2.56825 24.1169 3.32804 23.6483 3.7967L9.84828 17.5967C9.37962 18.0654 8.61982 18.0654 8.15121 17.5967Z"
                fill="currentColor"
              />
            </svg>
          </div>
          <TypeBody :variant="$options.Typography.Body.TEXT" tag="span">
            {{ item }}
          </TypeBody>
        </li>
      </ul>
    </div>
  </BaseCard>
</template>

<script>
import { AvatarImage, BaseCard, constants, TypeBody } from '@bambeehr/pollen';

const { Typography } = constants;
export default {
  name: 'HrmCard',
  Typography,
  components: {
    AvatarImage,
    BaseCard,
    TypeBody,
  },
  data() {
    return {
      checklist: [`5+ Years Experience`, `Supports All 50 States`],
    };
  },
};
</script>

<style scoped>
/* unique card width */
.hrm-card {
  width: 332px;
}

@media screen and (max-width: 767px) {
  .hrm-card {
    width: 312px;
  }
}

@media screen and (max-width: 380px) {
  .hrm-card {
    max-width: 375px;
    width: 100%;
  }
}
</style>
